declare const APP_NAME: string;
declare const BASE_URL: string;

export class General {
  public name: string = APP_NAME;
  public baseUrl: string = BASE_URL;
}

export default new General();
